import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { studentMode } from "@/utils/studentMode";
import { store } from "@/redux/store/store";
import { clearSessionExpired, resetAuth } from "@/redux/slice/auth.slice";
import { removeAuthToken } from "@/utils/storage";


const RouteCondition = ({ type, Component }) => {

  const getCurrentUserRole = () => {
    const path = window.location.pathname.toLowerCase();
    if (path.includes('/po/')) return 'PLACEMENT_OFFICER';
    if (path.includes('/student/')) return 'STUDENT';
    if (path.includes('/hr/')) return 'HUMAN_RESOURCE';
    return null;
  };

  const userRole = getCurrentUserRole();
  const { isAuth, role, mode, sessionExpired } = useSelector((state) => state.auth);
  const PRIVATEROUTES = ['EDIT_PORTFOLIO', 'PORTFOLIO']
  const PARAM_ROUTES = ['/student/otp', '/student/login-otp']
  const AUTH_ALLOWED_ROUTES = ['/student/login', '/student/register', '/student/havingissue']
  const route = studentMode(mode);


  if (!isAuth && type === 'auth' && type !== 'onboarding' && type !== 'private' && userRole === 'STUDENT') {
    const route = studentMode(mode);
    const currentPath = window.location.pathname;


    if (userRole === 'STUDENT') {
      if (AUTH_ALLOWED_ROUTES.includes(currentPath)) {
        return <Component />
      }
      else if (PARAM_ROUTES.includes(route)) {
        return <Component />
      }
      else {
        return <Navigate to="/student/login" replace />
      }
    }
  }
  else if (isAuth && type !== 'auth' && type === 'onboarding' && type !== 'private') {
    const route = studentMode(mode);
    const currentPath = window.location.pathname;

    if(sessionExpired ===  true && role === 'STUDENT') {
      store.dispatch(clearSessionExpired())
      store.dispatch(resetAuth())
      removeAuthToken()
      return <Navigate to="/student/login" replace />
    }

    if (role == 'STUDENT') {
      if (currentPath === route) {
        return <Component />
      }
      else {
        return <Navigate to={route} replace />
      }
    }
  }
  else if (isAuth && type !== 'auth' && type !== 'onboarding' && type === 'private' && PRIVATEROUTES.includes(mode) && role === userRole) {
    return <Component />
  }
  else if (isAuth && role !== userRole) {
    return <Navigate to="/not-authorized" replace />
  }
  else if (route && role === 'STUDENT' && mode !== null) {
    return <Navigate to={route} replace />
  }
  else {
    return <Navigate to="/not-authorized" replace />
  }
};

export default RouteCondition;
